// extracted by mini-css-extract-plugin
module.exports =  {"flex-gap":"wtPWXZS","flexGap":"wtPWXZS"};